import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CloseIcon } from '../../../assets/icons/close-bubble-icon.svg';

import classes from './Bubble.module.css';

const Bubble = (props) => {

  const {t} = useTranslation('global');
  
  let bubble = '';

  if (props.show){
    bubble = (
      <div role="region" aria-labelledby="bubbleTitle" className={classes.Bubble} onClick={props.click}>
        <h3 id="bubbleTitle" className="sr-only"> {t('widget.bubble.title')} </h3>
        <span dangerouslySetInnerHTML={{__html: t('widget.bubble.text')}} />
        <button 
          className= {classes.CloseButton} 
          onClick={(e) => {
            e.stopPropagation(); 
            props.close()}
          }
          title={t('widget.bubble.close')} 
          aria-label={t('widget.bubble.close')}>
          <CloseIcon/>
        </button>
      </div>
    )
  }

  return (
    <React.Fragment>
      {bubble}
    </React.Fragment>
    )
  }



export default Bubble;